import { Plus, Trash2 } from 'lucide-react';

// profile source (valley demo / own table / project pipe) + editable height table
export function ValleyProf({ x, src, pipes, prof, onSrc, setProf }) {
  const row = (i, k, v) => setProf(prof.map((p, j) => (j === i ? (k ? [p[0], v] : [v, p[1]]) : p)));
  return (
    <div className="vl-exp" data-testid="vl-prof">
      <label><span>{x.src}</span><select data-testid="vl-src" value={src} onChange={(e) => onSrc(e.target.value)}>
        <option value="demo">{x.srcDemo}</option>
        <option value="tab">{x.srcTab}</option>
        {pipes.length > 0 && <optgroup label={x.srcPipe}>{pipes.map((q) => <option key={q.p.id} value={`pipe:${q.p.id}`}>{`${q.p.name || q.p.id} (${Math.round(q.P.at(-1)[0])} m, ${q.P.length} ${x.pts})`}</option>)}</optgroup>}
      </select></label>
      {!pipes.length && <small className="muted" data-testid="vl-nopipes">{x.noPipes}</small>}
      {prof && <>
        <small className="muted">{x.profTab}</small>
        <table className="aq-cmp-t vl-ptab" data-testid="vl-ptab"><thead><tr><th>{x.s}</th><th>{x.z}</th><th /></tr></thead><tbody>
          {prof.map((p, i) => <tr key={i}>{[0, 1].map((k) => <td key={k}><input type="text" inputMode="decimal" data-testid={`vl-p${k ? 'z' : 's'}-${i}`} value={String(p[k]).replace('.', ',')} onChange={(e) => row(i, k, e.target.value.replace(/[^\d.,-]/g, ''))} /></td>)}
            <td><button type="button" className="icon-btn" data-testid={`vl-pdel-${i}`} disabled={prof.length <= 2} onClick={() => setProf(prof.filter((_, j) => j !== i))}><Trash2 size={14} /></button></td></tr>)}
        </tbody></table>
        <button type="button" className="chip" data-testid="vl-padd" onClick={() => { const a = prof.at(-1); setProf([...prof, [Math.round(+String(a[0]).replace(',', '.') + 100), a[1]]]); }}><Plus size={14} /> {x.add}</button>
      </>}
    </div>
  );
}
